// extracted by mini-css-extract-plugin
module.exports = {"author":"ContextAuthorCardEmpty__author","authorBlock":"ContextAuthorCardEmpty__authorBlock","authorImage":"ContextAuthorCardEmpty__authorImage"};